import { render, staticRenderFns } from "./Gocardless.vue?vue&type=template&id=2d440e2c&"
import script from "./Gocardless.vue?vue&type=script&lang=js&"
export * from "./Gocardless.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports